// ----------------------------------------------------------------------------
// Component: Headline block
// ----------------------------------------------------------------------------
//
// Contains a title and body text.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_headline-block.scss';
